<div class="row">
  <div class="col-md-6 rv-srt-itm">
    <h3>Reviews <span>({{length}})</span></h3>
    <div *ngIf="reviewList.length == 0" >
      <ul class="pr-list-rate-rvw">
        <li class="list-group">
          <p>No reviews available</p>
        </li>
      </ul>
    </div>
    <div>
      <ul class="pr-list-rate-rvw">
        <li class="list-group" *ngFor="let r of reviewList; let i = index">
          <h6>{{r.UserName}}</h6>
          <p>{{r.ReviewDescription}}</p>
          <i>{{r.CreatedDate}}</i>
        </li>
      </ul>
    </div>
    <div *ngIf="reviewList.length > 0">
      <mat-paginator [length]="length" [pageIndex]="pageIndex" [pageSize]="pageSize" [pageSizeOptions]="[5]" (page)="fn_GetReviewsData($event)">
      </mat-paginator>
    </div>
  </div>
</div>
